<template>
  <div class="w-full absolute flex justify-center items-center h-full px-4">
    <div class="max-w-sm">
      <div class="text-center">
        <van-image :src="appLogo" width="8rem" height="8rem" />
      </div>
      <van-form @submit="login">
        <van-field
          v-model="loginForm.username"
          placeholder="Username"
          :rules="[{ required: true, message: 'Username is required' }]"
        />
        <van-field
          v-model="loginForm.password"
          type="password"
          name="Password"
          placeholder="Password"
          :rules="[{ required: true, message: 'Password is required' }]"
        />
        <div class="mt-4 font-bold">
          <van-button round block class="bg-secondary" native-type="submit"> Login </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
  import axios from "@/plugins/axios";
  import { location } from "@/states/location";

  export default {
    name: "HomePage",

    data() {
      return {
        loginForm: {
          username: "",
          password: ""
        },
        peekPassword: false,
        location,
        appLogo: process.env.VUE_APP_LOGO || "/images/time_transparent.png",
      };
    },
    mounted() {
      if (localStorage.getItem("token") && !location.isMocked) {
        this.$router.push("/dashboard");
      }
    },

    methods: {
      login() {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: "Loading..."
        });

        if (location.isMocked) {
          this.$notify("Your account is locked!");
          return this.$toast.clear();
        }

        axios
          .post("/login", this.loginForm)

          .then((res) => {
            console.log("Login successful", res.status);
            axios.defaults.headers["Authorization"] = res.data.token;
            localStorage.setItem("token", res.data.token);
            try {
              window.NativeStorage.saveData("token", res.data.token);
            } catch (err) {
              console.error("Failed to save token in NativeStorage", err);
            }
            this.$toast.clear();
            this.$router.push("/dashboard");
          })
          .catch((err) => {
            console.error(err);
            this.$notify("Invalid username or password");
            this.$toast.clear();
          });
      }
    }
  };
</script>
